import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'weeklyProgress',
    label: 'Weekly Progress',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
